export class SearchPractitionerRequest {
  public static buildDefaultRequest(): SearchPractitionerRequest {
    const request = new SearchPractitionerRequest();
    request.setFilterText("");
    request.setStartIndex(0);
    request.setTotalPerPage(10);
    return request;
  }

  private filterText: string;
  private startIndex: number;
  private totalPerPage: number;

  public getFilterText(): string {
    return this.filterText;
  }

  public setFilterText(value: string): void {
    this.filterText = value;
  }

  public getStartIndex(): number {
    return this.startIndex;
  }

  public setStartIndex(value: number): void {
    this.startIndex = value;
  }

  public getTotalPerPage(): number {
    return this.totalPerPage;
  }

  public setTotalPerPage(value: number): void {
    this.totalPerPage = value;
  }
}
